// Tags every call the shared pages make from inside Teams, so the backend can
// tell them from the web app. The approve endpoints count Teams approvals this
// way for the review prompt (ADN-591); the assistant already sends the same
// value on its chat stream.
import type { InternalAxiosRequestConfig } from 'axios'

import api from '@src/api/api'
import { API_ADDRESS } from '@src/constants'

export const CLIENT_SOURCE_HEADER = 'X-Client-Source'
export const TEAMS_CLIENT_SOURCE = 'teams_web'

// Only our own API: a custom header on a call to another host (a presigned
// upload URL, say) would fail that host's CORS preflight.
const isOwnApi = (url = '') => !/^https?:\/\//i.test(url) || (!!API_ADDRESS && url.startsWith(API_ADDRESS))

export const tagAsTeamsClient = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (isOwnApi(config.url)) {
    config.headers[CLIENT_SOURCE_HEADER] = TEAMS_CLIENT_SOURCE
  }
  return config
}

api.interceptors.request.use(tagAsTeamsClient)
